// removed by extract-text-webpack-plugin
module.exports = {"row":"iB1BGJF6-0_W4G5wnfcsf"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/createStocktakeModal/styles.css
// module id = 1581
// module chunks = 0